import { IAggregate, IComputedAggregate } from '../../types';

export interface ISessionRangeTimestamps {
  start: number | null;
  end: number | null;
}

/**
 * @description get the start and end timestamp for a range of sessions (assumes the sessions are sorted descending by id)
 * @param sessions
 * @returns
 */
export const getSessionRangeTimestamps = (
  sessions: IComputedAggregate[]
): ISessionRangeTimestamps => {
  switch (sessions.length) {
    case 0:
      return { start: null, end: null };
    case 1: {
      const start = +sessions[0].meta.id;
      const end = +sessions[0].meta.id;
      return { start, end };
    }
    default: {
      const end = +sessions[0].meta.id;
      const start = +sessions[sessions.length - 1].meta.id;
      return { start, end };
    }
  }
};

/**
 * @description get the start and end timestamp for a range of sessions (assumes the sessions are sorted descending by id)
 * @param sessions
 * @returns
 */
export const getSessionRangeTimestampsForWeights = (
  sessions: IAggregate[]
): ISessionRangeTimestamps => {
  switch (sessions.length) {
    case 0:
      return { start: null, end: null };
    case 1: {
      const start = +sessions[0].id;
      const end = +sessions[0].id;
      return { start, end };
    }
    default: {
      const end = +sessions[0].id;
      const start = +sessions[sessions.length - 1].id;
      return { start, end };
    }
  }
};
